import { combineReducers } from '../../dependencies';

import filter from './filter';

export default combineReducers({
    filter,
});
